import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {Component, Injector} from "@angular/core";
import {InventoryGroupSearchPageComponent} from "../inventory-group-search-page/inventory-group-search-page.component";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {InventoryGroupSearchModel} from "../inventory-group-search.model";
import {InventoryGroupEditPageComponent} from "../inventory-group-edit-page/inventory-group-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

@Component({
    selector: "wbo-inventory-group-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(InventoryGroupSingleSelectEditControlComponent),
        provideSearchModel(InventoryGroupSearchModel)
    ]
})
export class InventoryGroupSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<InventoryGroupSearchModel> {
    constructor(model: InventoryGroupSearchModel, injector: Injector) {
        super(model, injector, "invGroupId", "name");
        this.extendedSearchComponent = InventoryGroupSearchPageComponent;
        this.extendedEditComponent = InventoryGroupEditPageComponent;
    }
}
